
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    errorCode: Number,
    refCode: String,
    onRefresh: Function
  }
})

export default class CoinHistoryHeader extends Vue {
  copyTextToClipboard(text: string) {
    const input = document.createElement('input')
    input.value = text
    input.setAttribute('readonly', 'readonly')
    document.body.appendChild(input)

    input.select()
    input.setSelectionRange(0, input.value.length)
    document.execCommand('copy')
    input.setAttribute('style', 'display:none')
  }
}
